export enum SubscriptionMember {
  PRIMARY_MEMBER = 'primaryMember',
  SECONDARY_MEMBER = 'secondaryMember',
}
